import axios from 'axios'
import qs from 'query-string'
import NProgress from 'nprogress'
import { storejs } from '../common/js/util'
import { Message } from 'element-ui'

var apiInstance = axios.create({
  baseURL: process.env.API_URL,
  timeout: 10000,
  withCredentials: true
})

//暂时不支持token传输
var apiCloudInstance = axios.create({
  baseURL: process.env.API_CLOUD_URL,
  timeout: 10000,
  withCredentials: true
})

apiInstance.defaults.headers.common['Authorization'] = 'Bearer ' + storejs.get(process.env.APPKEY + 'token')
apiCloudInstance.defaults.headers.common['Authorization'] = 'Bearer ' + storejs.get(process.env.APPKEY + 'token')

export function cleanToken() {
  apiInstance.defaults.headers.common['Authorization'] = ''
  apiCloudInstance.defaults.headers.common['Authorization'] = ''
}

// 登录
export const loginS = params => {
  return apiCloudInstance.post(`api-study/v1/users/login`, params)
}

//搜索
export const search = params => {
  return apiCloudInstance.get(`api-cms/v1/news`, {params: params})
}

export const queryCredit = params => {
  return apiCloudInstance.get(`api-study/v1/credit/creditStats`, {params: params})
}

// JWT验证
export const authJWT = params => {
  return apiCloudInstance.post(`gw/v1/authorizations/jwt`, params)
}

// 图形验证码验证
export const valilCaptcha = params => {
  return apiInstance.get(`api/public/captcha/valilCaptcha`, {params: params})
}

// 发送手机验证码
export const sendSms = params => {
  return apiInstance.get(`api/public/sms/sendSMS`, {params: params})
}

// 验证手机验证码
export const validateMobileCode = params => {
  return apiInstance.get(`api/public/sms/validateMobileCode`, {params: params})
}

// 验证验证证件号唯一性
export const verificationStudent = params => {
  return apiInstance.get(`api/study/student/verificationStudent`, {params: params})
}

// 验证手机号唯一性
export const vftelStudent = params => {
  return apiInstance.get(`api/study/student/vftelStudent`, {params: params})
}

// 验证用户名唯一性
export const checkUsername = params => {
  return apiInstance.get(`api/study/student/checkUsername`, {params: params})
}

// // 学员注册
// export const studyRegister = params => {
//   return apiInstance.post(`api/study/student/register`, params)
// }
// 学员注册
export const studyRegister = (params) => {
  return apiCloudInstance.post(`openplatfrom-userserver/user/register`, params)
}

export const teachManageLogin = params => {
  return apiInstance.post(`api/study/user/login`, params)
}

// 获得学员的字典信息
export const getUserDictByColumType = params => {
  return apiInstance.get(`api/study/student/getUserDictByColumType`, {params: params})
}

// 获得省市县乡
export const getCustomAreaList = params => {
  return apiInstance.get(`api/study/public/getCustomAreaList`, {params: params})
}

// 获得单位下的科室
export const getdepartmentByOrgId = params => {
  return apiInstance.get(`api/study/student/getdepartmentByOrgId`, {params: params})
}

// 获得专业1
export const getSpecialty1Indexs = params => {
  return apiInstance.get(`api/study/student/getSpecialty1Indexs`, {params: params})
}

// 获得专业2
export const getSpecialty2Indexs = params => {
  return apiInstance.get(`api/study/student/getSpecialty2Indexs`, {params: params})
}

// 验证学员是否有学习前需要的考试
export const showExamVisible = params => {
  return apiInstance.get(`api/study/student/showExamVisible`, {params: params})
}

// 轮播图列表
export const getRecommendList = params => {
  return apiCloudInstance.get(`api-cms/cms/carouselFigure/getRecommendList`, {
    params: params
  })
}

// 资讯列表
export const listNews = params => {
  return apiInstance.get(`api/cms/news/list`, {params: params})
}

// 资讯详情
export const getNews = params => {
  return apiInstance.get(`api/cms/news/getNews`, {params: params})
}

// 精品课程
export const listPerfectCourse = params => {
  return apiInstance.get(`api/study/course/perfect/list`, {params: params})
}

// 学员培训班列表
export const listStudentTraining = params => {
  return apiInstance.get(`api/study/student/listStudentTraining`, {params: params})
}

// 学科分类
export const listDisciplineCategoryAndChild = () => {
  return apiInstance.get(`api/category/listDisciplineCategoryAndChild`)
}

// 项目和课程以及课程学习状态列表
export const listStudentProjCourseInfoAndStatus = params => {
  return apiInstance.get(`api/study/student/listStudentProjCourseInfoAndStatus`, {params: params})
}

// 项目列表和学习状态列表
export const listStudentProjInfoAndStatus = params => {
  return apiInstance.get(`api/study/student/listStudentProjInfoAndStatus`, {params: params})
}
// 项目列表和学习状态列表(专家)
export const listStudentProjInfoAndStatusForExpert = params => {
  return apiInstance.get(`api/study/student/listStudentProjInfoAndStatusForExpert`, {params: params}).then(res => res.data)
}

// 继教我的项目列表
export const listStudentMyProjInfoAndStatus = params => {
  return apiInstance.get(`api/study/student/listStudentMyProjInfoAndStatus`, {params: params})
}

// 课件列表
export const getCourseWareByCourse = params => {
  return apiInstance.get(`api/study/courseware/getCourseWareByCourse`, {params: params})
}

// 用户课程视频完成情况
export const getUserCoursePercent = (userId, params) => {
  return apiCloudInstance.get(`api-study/v1/users/` + userId + `/course/percent`, {params: params})
}
// 用户提交课程评星
export const saveCourseRate = params => {
  return apiInstance.post(`api/study/courseware/rate/save`, params)
}

// 同步讲义状态
export const syncHandoutStatus = params => {
  return apiInstance.post(`api/study/course/syncHandoutStatus`, params)
}

// 同步课程状态
export const syncCourseStatus = params => {
  return apiInstance.post(`api/study/course/syncCourseStatus`, params)
}

// 证书查询
export const getCertificate = params => {
  return apiInstance.get(`api/Certificate/getCertificate`, {params: params})
}

// 学员是否有思维训练
export const getUserThinking = params => {
  return apiInstance.get(`api/study/student/getUserThinking`, {params: params})
}

// 绑定学习卡
export const bandLearningCard = params => {
  return apiInstance.post(`api/study/learningCard/bandLearningCard`, params)
}

// 我的培训
export const getMyTrainingList = params => {
  return apiInstance.get(`api/study/student/getMyTrainingList`, {params: params})
}

// 根据培训班id获取培训班
export const getTrainingById = params => {
  return apiInstance.get(`api/study/training/getTrainingById`, {params: params})
}

// 根据培训班id获取培训班
export const getTrainingInfoById = params => {
  return apiInstance.get(`api/study/training/getTrainingInfoById`, {params: params})
}

// 我的学分
export const getMyScoreList = params => {
  return apiInstance.get(`api/study/student/getMyScoreList`, {params: params})
}

// 获取服务器当前时间
export const getServerNowTime = () => {
  return apiInstance.get(`api/study/student/getServerNowTime`)
}

// 我的学分(获取所有培训班的年份)
export const getMyScoreTrainingYear = params => {
  return apiInstance.get(`api/study/student/getMyScoreTrainingYear`, {params: params})
}

// 我的学分 (根据年份获取对应的培训班)
export const getMyScoreTrainingName = params => {
  return apiInstance.get(`api/study/student/getMyScoreTrainingName`, {params: params})
}

// 我的考试
export const getUserCenterExamLists = params => {
  return apiInstance.get(`api/study/student/usercenter/exam`, {params: params})
}


// 我的练习
export const getUserCenterPractiseLists = params => {
  return apiInstance.get(`api/study/student/usercenter/practise`, {params: params})
}

// 我的练习
export const validateUserCreditBindingTerm = params => {
  return apiInstance.get(`api/study/student/usercenter/validateUserCreditBindingTerm`, {params: params})
}

// 绑卡记录
export const getMyCardList = params => {
  return apiInstance.get(`api/study/student/getMyCardList`, {params: params})
}

// 获取继教项目详情
export const getProjectDetail = params => {
  return apiInstance.get(`api/study/project/getProjectDetail`, {params: params})
}

//获取学员的详细信息
export const getStudentDetail = params => {
  return apiInstance.get(`api/study/student/getStudentDetail`, {params: params})
}

// 编辑学员的基本信息
export const updateStudent = params => {
  return apiInstance.post(`api/study/student/updateStudent`, params)
}

// 账号设置：修改手机号
export const updateMobile = params => {
  return apiInstance.post(`api/study/student/updateMobile`, params)
}


// 账号设置：发送邮箱验证码
export const sendEmail = params => {
  return apiInstance.get(`api/public/email/sendEmail`, {params: params})
}

// 账号设置：验证邮箱验证码
export const validateEmailCode = params => {
  return apiInstance.get(`api/public/email/validateEmailCode`, {params: params})
}

// 忘记密码
export const updatePwd = params => {
  return apiInstance.post(`api/study/student/updatePwd`, params)
}

//短信找回密码 新短信接口
export const updatePwdNew = (params) => {
  return apiCloudInstance.post(
    `openplatfrom-userserver/user/editPasswordByMobile`,
    params
  )
}

//账号设置：修改密码（验证旧密码是否正确）
export const checkPwdRight = params => {
  return apiInstance.get(`api/study/student/checkPwdRight`, {params: params})
}

//账号设置：修改密码（验证旧密码是否正确）
export const updateEmail = params => {
  return apiInstance.get(`api/study/student/updateEmail`, {params: params})
}

//账号设置：修改密码（验证邮箱是否唯一）
export const vftelUserEmail = params => {
  return apiInstance.get(`api/study/student/vftelUserEmail`, {params: params})
}

// 账号设置：修改密码
export const updatePassword = params => {
  return apiInstance.post(`api/study/student/updatePassword`, params)
}

// 我的考试列表 开始考试按钮的 验证
export const validateTrainingExam = params => {
  return apiInstance.get(`api/study/student/validateTrainingExam`, {params: params})
}

// 获取继教项目的课程
export const getProjectCourse = params => {
  return apiInstance.get(`api/study/project/getProjectCourse`, {params: params})
}

// 添加到我的项目
export const addMyProject = params => {
  return apiInstance.post(`api/study/project/usercenter/addMyProject`, params)
}

// 取消申请学分
export const calcelApplyCredit = params => {
  return apiInstance.post(`api/study/credit/calcelApplyCredit`, params)
}

// 申请学分
export const applyCredit = params => {
  return apiInstance.post(`api/study/credit/applyCredit`, params)
}

//查询培训班关联的考试要求设置
export const getUserTrainingExam = params => {
  return apiInstance.get(`/api/study/training/getUserTrainingExam`, {params: params})
}

// 检测学员是否绑定了学习卡
export const haveBandedLearningCard = params => {
  return apiInstance.get(`api/study/learningCard/haveBandedLearningCard`, {params: params})
}

// 根据单位名称模糊匹配获取单位信息，以及省市县乡
export const listByCompName = params => {
  return apiInstance.get(`api/study/comp/listByCompName`, {params: params})
}

// 课后练习分数提交
export const commitCoursePracticeScore = params => {
  return apiInstance.get(`api/WebApp/commitCoursePracticeScore`, {params: params})
}

// 获取继教项目类别
export const getProjTypeList = params => {
  return apiInstance.get(`api/study/project/getProjDict`, {params: params})
}

// 获取继教学分类别
export const getCreTypeList = params => {
  return apiInstance.get(`api/study/project/getProjDict`, {params: params})
}


// 继教--添加到我的项目
export const addToMyProject = params => {
  return apiInstance.get(`api/study/project/addToMyProject`, {params: params})
}

// 继教--从我的项目中移除
export const removeFromMyProject = params => {
  return apiInstance.get(`api/study/project/removeFromMyProject`, {params: params})
}

//医搜索
export const MedicalSearch = params => {
  return apiInstance.post(`api/common/MedicalSearch`, params)
}

//判断学员是否是指定地区或医院
export const existAssignOrg = params => {
  return apiInstance.post(`api/study/student/existAssignOrg`, params)
}

// 获取考试的url
export const getBeginExamUrl = params => {
  return apiInstance.get(`api/study/public/getBeginExamUrl`, {params: params})
}

// 获取练习的url
export const getBeginPracticeUrl = params => {
  return apiInstance.get(`api/study/public/getBeginPracticeUrl`, {params: params})
}

// 获取查看考试的url
export const getViewExamAnswerUrl = params => {
  return apiInstance.get(`api/study/public/getViewExamAnswerUrl`, {params: params})
}

// 获取二级登陆页配置信息
export const getSecondPageInfoById = params => {
  return apiInstance.get(`api/study/secondPage/getSecondPageInfoById`, {params: params})
}

// 提交评论
export const saveComment = params => {
  return apiInstance.post(`api/comment/save`, params)
}

// 评论列表
export const listComment = params => {
  return apiCloudInstance.get(`api-cms/v1/comments/topic`, {params: params})
}

// 根据微信扫码第一步获取的code 获取access_token
export const getWXCallBack = params => {
  return apiCloudInstance.get(`api-weixin/v1/wx/callback`, {params: params})
}

// 根据微信扫码第一步获取的code 刷新access_token
export const refreshAccessToken = params => {
  return apiCloudInstance.get(`api-weixin/v1/wx/refreshAccessToken`, {params: params})
}

// 微信openId绑定医博士账号
export const bandUser = params => {
  return apiCloudInstance.post(`api-study/v1/wxUser/bandUser`, params)
}

// 根据openId获取对应 医博士账户的 jwtToken
export const getJwtTokenByOpenId = openIdWeb => {
  return apiCloudInstance.get('api-study/v1/wxUser/' + openIdWeb + '/jwtToken')
}

// 支付统一下单
export const unifiedorder = params => {
  return apiCloudInstance.post(`api-public/v1/pay/unifiedorder`, params)
}

// 笔记列表
export const listNotes = (userId, params) => {
  return apiCloudInstance.get(`api-study/v1/users/` + userId + `/notes`, {params: params})
}

// 增加笔记
export const saveNote = params => {
  return apiCloudInstance.post(`api-study/v1/notes`, params)
}

// 设备检验接口(检测设备是否在线)
export const singleDeviceCheck = (params) => {
  return apiCloudInstance.get(
    `/api-video/v2/video/singleDevice/check`,
    params
  )
}

// 设备检验接口(切换设备)
export const singleDeviceSwitch = (params) => {
  return apiCloudInstance.post(
    `/api-video/v1/video/singleDevice/switch`,
    params
  )
}

/**
 * @description: 学习签到记录
 */
export const trainingSignIn = (params) => {
  return apiCloudInstance.get(`/api-study/v1/trainings/signIn`, {
    params: params
  })
}

/**
 * @description: 视频锁定操作
 */
export const postVideoCheckOnlineStudy = (params) => {
  return apiCloudInstance.post(`api-study/v1/video/checkOnlineStudy`, params)
}

/**
 * @description: 修改密码
 */
export const userUpdatePassword = (params) => {
  return apiCloudInstance
    .post(`openplatfrom-userserver/user/updatePassword`, params)
    .then((res) => res.data)
}
// 验证用户登录名证件号是否可用
export const nameSertIdAvailable = (params) => {
  return apiCloudInstance.get(`openplatfrom-userserver/user/available/value`, {
    params: params,
    hideMsg: true
  })
}
// 绑定手机号
export const bindMobile = (params) => {
  return apiCloudInstance.post(
    `openplatfrom-userserver/user/bindMobile`,
    params
  )
}

export const listCompany = (params) => {
  return apiCloudInstance
    .get(`api-study/v1/companys`, {params: params})
    .then((res) => res.data)
}

//修改绑定手机号
export const updatebindMobile = (params) => {
  return apiCloudInstance.post(
    `openplatfrom-userserver/user/editMobile`,
    params
  )
}

// 加载拦截
apiInstance.interceptors.request.use(function (config) {
  NProgress.start()
  
  //注意跟后台交互时array会被自动转换，
  //https://www.npmjs.com/package/query-string
  if (config.method === 'post') {
    config.data = qs.stringify(config.data)
  }
  
  //解决第一次登陆初始化实例没有token问题
  if (!apiInstance.defaults.headers.common['Authorization'] || (apiInstance.defaults.headers.common['Authorization'].split('.')).length - 1 == 0) {
    config.headers.common['Authorization'] = 'Bearer ' + storejs.get(process.env.APPKEY + 'token')
  }
  return config
}, function (error) {
  NProgress.done()
  return Promise.reject(error)
})

apiInstance.interceptors.response.use(function (response) {
  NProgress.done()
  return response
}, function (error) {
  if (!(error.config.url.indexOf('api/study/student/authJWT') != -1)) {
    Message.error('网络异常！')
  }
  NProgress.done()
  return Promise.reject(error)
})

// 不需要经过qs转换的api地址
const WhiteList = [
  '/api-video/v1/video/singleDevice/check',
  '/api-video/v1/video/singleDevice/switch',
  'openplatfrom-userserver/user/updatePassword'
]
apiCloudInstance.interceptors.request.use(function (config) {
  NProgress.start()
  
  //注意跟后台交互时array会被自动转换，
  //https://www.npmjs.com/package/query-string
  if (config.method === 'post' && WhiteList.indexOf(config.url) === -1) {
    config.data = qs.stringify(config.data)
  }
  
  //解决第一次登陆初始化实例没有token问题
  if (!apiCloudInstance.defaults.headers.common['Authorization'] || (apiCloudInstance.defaults.headers.common['Authorization'].split('.')).length - 1 == 0) {
    config.headers.common['Authorization'] = 'Bearer ' + storejs.get(process.env.APPKEY + 'token')
  }
  return config
}, function (error) {
  NProgress.done()
  return Promise.reject(error)
})

apiCloudInstance.interceptors.response.use(function (response) {
  NProgress.done()
  if (response.data.code == 1) {
    Message.error(response.data.msg)
    return Promise.reject(response.data)
  }
  return response
}, function (error) {
  if (!(error.config.url.indexOf('gw/v1/authorizations/jwt') != -1)) {
    Message.error('网络异常！')
  }
  NProgress.done()
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/api/api.js